<app-sidebar></app-sidebar>
<app-headbar></app-headbar>


<div class="bb-main-container">
  <h2 class="mb-4">Stats</h2>
  </div>